import React from "react";
import HeaderLeft from "./HeaderLeft";
import { Link } from "react-router-dom";
import DropdownRight from "./DropdownRight";

function BackHome(props) {
  return (
    <>
      <header>
        <div class="custom_container ">
          <HeaderLeft />
          <div class="user_profile">
            <DropdownRight />
          </div>
        </div>
      </header>
      <section class="otp_verification custom_hight">
        <div class="login_inner">
          <h1 class="mb_30 main_title ">We'll be with you shortly</h1>
          {/* <p class="mb_40 them_para text-center mx-auto text_limit">
            Dear user, we have received your sample Evo. Our experts will review
            it now and we'll let you know if you are eligible for this post or
            not
          </p> */}
          <div class="btn_wraper">
            <Link to="/uploadNewPracticeVideo">
              <button type="button" class="them_btn mt_40 mb_30">
                Back Home
              </button>
            </Link>
          </div>
        </div>
      </section>
    </>
  );
}

export default BackHome;
